import type { IconSvgObject } from './types';

const PlusSignIcon: IconSvgObject = [
  ["path", { d: "M12 4V20M20 12H4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PlusSignIcon;
